import { SideBySideView } from './SideBySideView';
import { SliderView } from './SliderView';
import { ToggleView } from './ToggleView';
import type { CompareImages, CompareMode, ToggleSide } from './types';
import type { SliderState } from './useSliderPosition';

export interface CompareStageProps extends CompareImages {
  mode: CompareMode;
  slider: SliderState;
  side: ToggleSide;
  onSideChange: (side: ToggleSide) => void;
  fullscreen?: boolean;
  onExpand?: () => void;
}

/** Renders the active comparison mode; shared by the inline card and the fullscreen view. */
export function CompareStage({ mode, slider, side, onSideChange, onExpand, ...images }: CompareStageProps) {
  switch (mode) {
    case 'slider':
      return <SliderView {...images} slider={slider} />;
    case 'side-by-side':
      return <SideBySideView {...images} onExpand={images.fullscreen ? undefined : onExpand} />;
    case 'toggle':
      return <ToggleView {...images} side={side} onSideChange={onSideChange} />;
  }
}
